



















































import Vue, { PropType } from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
  name: "DeleteItem",
  props: {
    title: {
      type: String as PropType<TranslateResult>,
      required: true
    },
    sub_title: {
      type: String as PropType<TranslateResult>
    },
    submit_btn_text: {
      type: String as PropType<TranslateResult>,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String as PropType<string>,
      default: require("@/assets/icons/bold/trash.svg")
    },
    transform_source_color: {
      type: String,
      default: "#E32D6B"
    }
  },
  methods: {
    transform_del_icon(icon: HTMLElement): HTMLElement {
      for (let node of icon.children)
        node.setAttribute("fill", this.transform_source_color);
      return icon;
    }
  }
});
